import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20-dialog', {
    attrs: {
      "persistent": "",
      "title": _vm.$i18n_t('Dashboards.components.dashboardParametersDialog.title'),
      "action-save-loading": _vm.isSaving,
      "action-save-label": _vm.$t('Common.save'),
      "isOpen": _vm.show,
      "max-width": "800px"
    },
    on: {
      "close": function ($event) {
        _vm.show = false;
      },
      "action:save": _vm.save
    }
  }, [_c('p', {
    staticClass: "card-description"
  }, [_vm._v("\n    " + _vm._s(_vm.$i18n_t('Dashboards.components.dashboardParametersDialog.description')) + "\n  ")]), Object.keys(_vm.editedParameters).length === 0 ? _c('core-button', {
    attrs: {
      "data-cy": "btn_add",
      "title": _vm.$i18n_t('Common.addNew'),
      "color": _vm.color,
      "prepend-icon": "fa-plus"
    },
    on: {
      "click": _vm.addEmptyParameter
    }
  }) : _vm._e(), _vm._l(Object.entries(_vm.editedParameters), function ([key, value], index) {
    return _c(VRow, {
      key: `parameter_${index}`
    }, [_c(VCol, [_c(VTextField, {
      attrs: {
        "label": _vm.$t('Dashboards.components.dashboardParametersDialog.inputs.parameterKey.label'),
        "value": key,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "hide-details": ""
      },
      on: {
        "input": function ($event) {
          return _vm.updateParameterKey(key, $event);
        }
      }
    })], 1), _c(VCol, {
      staticClass: "dashboard-parameters-add-dialog-input-row-col"
    }, [_c(VTextField, {
      attrs: {
        "label": _vm.$t('Dashboards.components.dashboardParametersDialog.inputs.parameterDefaultValue.label'),
        "value": value,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "hide-details": ""
      },
      on: {
        "input": function ($event) {
          return _vm.updateParameterDefaultValue(key, $event);
        }
      }
    })], 1), _c(VCol, {
      attrs: {
        "cols": "auto"
      }
    }, [_c('core-button', {
      attrs: {
        "title": _vm.$i18n_t('Common.addNew'),
        "color": _vm.color,
        "prepend-icon": "fa-plus",
        "data-cy": "btn_add"
      },
      on: {
        "click": _vm.addEmptyParameter
      }
    }), _c('core-button', {
      attrs: {
        "title": _vm.$i18n_t('Common.delete'),
        "color": _vm.color,
        "prepend-icon": "fa-trash-alt",
        "data-cy": "btn_delete"
      },
      on: {
        "click": function ($event) {
          return _vm.removeParameter(key);
        }
      }
    })], 1)], 1);
  })], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };